<template>
  <div @click="active" style="cursor: pointer">
    <div  class="close"><img src="../../../assets/label-close.png" @click.stop="close"></div>
    <div class="title">{{title}}</div>
  </div>

</template>

<script>

  export default {
    name: "page-put-tag",
      props: {
        title: {type: String, require: true},
        name:{type:String,require:true},
        closeable:{type:Boolean,default:true},
        selected:{type:Boolean,default:false},
      },
    data() {
      return {
      }
    },
    computed: {},
    watch: {
    },
    methods: {
      close() {
        this.$emit("close");
      },
      active(){
        this.$emit("active");
      }
    },
    mounted() {
      // console.log(this.selected);
      if (this.selected) {
        this.$emit("isSelect");
      }
    },

  }
</script>

<style scoped>
  .close{
    float:right;
    padding-right:10px;
  }
  .title{
    padding-left:20px;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/views/components/PageTagList/page-put-tag.vue